import { connectAppStore } from "../../../../../Store/AppStore";
import PageDependencies from "../../../../../Feature/PageDependencies";

const SolarPvModule = (props) => {
    const { 
        Fragment,
        useEffect,
        useState,
        useParams,
        tryCatchFinally,
        layoutManager,
        getData,
        cookiesManager,
        guid,
        useReducerSmart,
        toastPrint,
        BindedInput,
        BindedCheckBox,
        BindedSelect,
        getAppStore,
        pageProfile,
        AppLoading,
        loaModelFromApi,
        FormValidate
    } = PageDependencies();
    const debug = layoutManager.Layout_GetDebugModel(props);
    const defaultParams = pageProfile.getDefaultParams(useParams());
    const [init, setInit] = useState(false);
    const defaultViewModel = {
        ...defaultParams,
    };
    const [viewModel, dispatchViewModel, bindingViewModel] = useReducerSmart(defaultViewModel);
    const [loading, setLoading] = useState({ isLoading: false, text: "" });
    const [appStoreState, appStoreDispatch] = getAppStore(props);
    const getUrl = "api/NewHome/SolarPvModule/Accessor/Get";
    const [reloadForm, setReloadForm] = useState("");
    const formId = "SolarPVOrientationDetail";
    const [elementTableType, setElementTableType] = useState("Orientation1");
    const validateMethods = {
        numberOfOrientations:(value)=>{ return FormValidate.validateNumberBetween(value, "Number of Orientations", 0, 3);}, 
        totalCapacityInverters:(value)=>{ return FormValidate.validateNumberGreaterThan0(value, "Capacity inverters");},
        networkLimit:(value)=>{ return FormValidate.validateNumberGreaterThanOrEqual0(value, "Network limit");},
    };
    const formValidate = new FormValidate(useState(validateMethods), useState(), useState(), useState(),false);

    useEffect(()=>{
        layoutManager.Layout_Headter_Footer_SideBar(props);
        loaModelFromApi.loadDefault(true, getUrl, viewModel, dispatchViewModel, setLoading, "Loading Solar PV", appStoreDispatch, undefined, setInit);
    },[reloadForm]);

    useEffect(()=>{
        if(init){
            if (viewModel.numberOfOrientations >= 1){
                handleTagClick("Orientation" + viewModel.numberOfOrientations.toString());
            }
        }
    }, [viewModel.numberOfOrientations]);

    const submit = ()=>{
        formValidate.setValidateVisibility(true);
        const validateResult = formValidate.checkValidateResult(viewModel);
        if(!validateResult) return;
        const postUrl = "api/NewHome/SolarPvModule/Accessor/UpdateSolarPv";
        setLoading({ isLoading: true, text: "Updating Solar PV" });
        tryCatchFinally.syncProcess(async()=>{
            const response = await getData.processPost(true, postUrl, viewModel);
            toastPrint.printResponse(response);
            setReloadForm(guid.newGuid());
            handleTagClick("Orientation1");
        }, setLoading);
    }

    const handleTagClick = (elementTableType) => {
        setElementTableType(elementTableType);
        cookiesManager.setCookies(formId, { elementTableType: elementTableType });
    }

    const generateTagClass = (elementType) => {
        let className = elementType == elementTableType ? "active" : "";
        className = "nav-link show " + className;
        return className;
    }

    return (
        <Fragment>
            {debug && <p>{JSON.stringify(viewModel)}</p>}
            {loading.isLoading && (<AppLoading active><div>{loading.text}</div></AppLoading>)}
            <div className="app-main__inner">
                <div className="app-page-title">
                    <div className="page-title-wrapper">
                        <div className="page-title-heading">
                            <div className="page-title-icon">
                                <i className="pe-7s-sun icon-gradient bg-tempting-azure">
                                </i>
                            </div>
                            <div>
                                Solar PV
                                <div className="page-title-subheading">
                                    {pageProfile.getPageSubTitle(appStoreState)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {init === true &&
                    <>
       <div className="main-card mb-3 card">
                    <div className="card-header">
                        <button type="button" data-toggle="collapse" data-target="#AnnualEnergyConsumptionDiv" aria-expanded="true" aria-controls="AnnualEnergyConsumptionDiv" className="text-left m-0 p-0 btn btn-block">
                            <h5 className="m-0 p-0 card-title">Annual PV Generation</h5>
                        </button>
                    </div>
                    <div data-parent="#AnnualEnergyConsumptionAccordion" id="AnnualEnergyConsumptionDiv" className="collapse show">
                        <div className="card-body">
                            <div className="separator"></div>
                            <div className="form-row row">
                                <div className="col-4">
                                    <div className="position-relative form-group">
                                        <label>Electricity Generation (kWh/yr): {parseFloat(viewModel.annualElectricityGenerationEnergy).toFixed(2)}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="main-card mb-3 card">
                    <div className="card-header">
                        <button type="button" data-toggle="collapse" data-target="#HeatingConditionersListDiv" aria-expanded="true" aria-controls="HeatingConditionersListDiv" className="text-left m-0 p-0 btn btn-block">
                            <h5 className="m-0 p-0 card-title">Solar PV Configuration</h5>
                        </button>
                    </div>
                    <div data-parent="#HeatingConditionersList" id="HeatingConditionersListDiv" className="collapse show">
                        <div className="card-body">
                            <div className="separator"></div>
                            <div className="form-row row">
                                <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                                    <div className="form-row row">
                                        <div className="col-lg-7 col-7">
                                            <label htmlFor="NumberOfOrientations">Number Of Orientations *</label>
                                        </div>
                                        <div className="col-lg-3 col-3">
                                            <BindedInput
                                                className="form-control"
                                                id="NumberOfOrientations"
                                                name="NumberOfOrientations"
                                                min="0"
                                                max="3"
                                                type="number"
                                                validate={formValidate}
                                                binding={[viewModel, "numberOfOrientations", bindingViewModel]}
                                            ></BindedInput>
                                        </div>
                                    </div>
                                    <div className="form-row row">
                                        <div className="col-lg-7 col-7">
                                            <label htmlFor="SoilingLosses">Soiling Losses </label>
                                        </div>
                                        <div className="col-lg-3 col-3">
                                            <BindedInput
                                                disabled
                                                className="form-control"
                                                id="SoilingLosses"
                                                name="SoilingLosses"
                                                type="number"
                                                binding={[viewModel, "soilingLosses", bindingViewModel]}
                                            ></BindedInput>
                                        </div>
                                    </div>
                                    <div className="form-row row">
                                        <div className="col-lg-7 col-7">
                                            <label htmlFor="DcWiringLosses">Dc Wiring Losses </label>
                                        </div>
                                        <div className="col-lg-3 col-3">
                                            <BindedInput
                                                disabled
                                                className="form-control"
                                                id="DcWiringLosses"
                                                name="DcWiringLosses"
                                                type="number"
                                                binding={[viewModel, "dcWiringLosses", bindingViewModel]}
                                            ></BindedInput>
                                        </div>
                                    </div>
                                    <div className="form-row row">
                                        <div className="col-lg-7 col-7">
                                            <label htmlFor="ConversionLosses">Conversion Losses </label>
                                        </div>
                                        <div className="col-lg-3 col-3">
                                            <BindedInput
                                                disabled
                                                className="form-control"
                                                id="ConversionLosses"
                                                name="ConversionLosses"
                                                type="number"
                                                binding={[viewModel, "conversionLosses", bindingViewModel]}
                                            ></BindedInput>
                                        </div>
                                    </div>
                                    <div className="form-row row">
                                        <div className="col-lg-7 col-7">
                                            <label htmlFor="StandardAmountOfRadiationUsed">Standard amount of radiation used </label>
                                        </div>
                                        <div className="col-lg-3 col-3">
                                            <BindedInput
                                                disabled
                                                className="form-control"
                                                id="StandardAmountOfRadiationUsed"
                                                name="StandardAmountOfRadiationUsed"
                                                type="number"
                                                binding={[viewModel, "standardAmountOfRadiationUsed", bindingViewModel]}
                                            ></BindedInput>
                                        </div>
                                    </div>
                                    <div className="form-row row">
                                        <div className="col-lg-7 col-7">
                                            <label htmlFor="TimeZone">Time Zone </label>
                                        </div>
                                        <div className="col-lg-3 col-3">
                                            <BindedInput
                                                disabled
                                                className="form-control"
                                                id="TimeZone"
                                                name="TimeZone"
                                                type="number"
                                                binding={[viewModel, "timeZone", bindingViewModel]}
                                            ></BindedInput>
                                        </div>
                                    </div>
                                    <div className="form-row row">
                                        <div className="col-lg-7 col-7">
                                            <label htmlFor="TotalCapacityInverters">Total Capacity of Inverters (kW)</label>
                                        </div>
                                        <div className="col-lg-3 col-3">
                                            <BindedInput
                                                className="form-control"
                                                id="TotalCapacityInverters"
                                                name="TotalCapacityInverters"
                                                type="number"
                                                max="999"
                                                min="0"
                                                validate={formValidate}
                                                binding={[viewModel, "totalCapacityInverters", bindingViewModel]}
                                            ></BindedInput>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12" id="Oriententions">
                                {viewModel.numberOfOrientations > 0 &&
                                    <div id="AdditionalCards" className="main-card mb-3 card">
                                        <div className="card-header">
                                            <ul className="nav nav-justified">
                                                <li className="nav-item" onClick={() => handleTagClick("Orientation1")}><a className={generateTagClass("Orientation1")}>Orientation 1</a></li>
                                                {viewModel.numberOfOrientations > 1 &&
                                                <li className="nav-item" onClick={() => handleTagClick("Orientation2")}><a className={generateTagClass("Orientation2")}>Orientation 2</a></li>}
                                                {viewModel.numberOfOrientations > 2 &&
                                                <li className="nav-item" onClick={() => handleTagClick("Orientation3")}><a className={generateTagClass("Orientation3")}>Orientation 3</a></li>}
                                            </ul>
                                        </div>
                                        <div data-parent="#ConstructionsAccordion" id="ConstructionsCollapsibleDiv" className="collapse show">
                                            <div className="card-body">
                                                <div className="separator"></div>
                                                {elementTableType === 'Orientation1' && <Fragment>
                                                    <div className="col-lg-12 col-12">
                                                        <div className="position-relative form-group">
                                                            <div className="form-row row">
                                                                <div className="col-lg-7 col-7">
                                                                    <label id="CollectorSlope1Label" htmlFor="CollectorSlope1">PV Collector Slope</label>
                                                                </div>
                                                                <div className="col-lg-3 col-3">
                                                                    <BindedInput
                                                                        className="form-control"
                                                                        id="CollectorSlope1"
                                                                        name="CollectorSlope1"
                                                                        type="number"
                                                                        binding={[viewModel, "collectorSlope1", bindingViewModel]}
                                                                    ></BindedInput>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12 col-12">
                                                        <div className="position-relative form-group">
                                                            <div className="form-row row">
                                                                <div className="col-lg-7 col-7">
                                                                    <label id="Size1Label" htmlFor="Size1">PV Size</label>
                                                                </div>
                                                                <div className="col-lg-3 col-3">
                                                                    <BindedInput
                                                                        className="form-control"
                                                                        id="Size1"
                                                                        name="Size1"
                                                                        type="number"
                                                                        binding={[viewModel, "size1", bindingViewModel]}
                                                                    ></BindedInput>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12 col-12">
                                                        <div className="position-relative form-group">
                                                            <div className="form-row row">
                                                                <div className="col-lg-7 col-7">
                                                                    <label id="AzimuthAngle1Label" htmlFor="AzimuthAngle1">PV Collector Surface Azimuth Angle</label>
                                                                </div>
                                                                <div className="col-lg-3 col-3">
                                                                    <BindedInput
                                                                        className="form-control"
                                                                        id="AzimuthAngle1"
                                                                        name="AzimuthAngle1"
                                                                        type="number"
                                                                        binding={[viewModel, "azimuthAngle1", bindingViewModel]}
                                                                    ></BindedInput>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12 col-12">
                                                        <div className="position-relative form-group">
                                                            <div className="form-row row">
                                                                <div className="col-lg-7 col-7">
                                                                    <label id="DiffuseReflectance1Label" htmlFor="DiffuseReflectance1">Diffuse Reflectance</label>
                                                                </div>
                                                                <div className="col-lg-3 col-3">
                                                                    <BindedInput
                                                                        disabled
                                                                        className="form-control"
                                                                        id="DiffuseReflectance1"
                                                                        name="DiffuseReflectance1"
                                                                        type="number"
                                                                        binding={[viewModel, "diffuseReflectance1", bindingViewModel]}
                                                                    ></BindedInput>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    </Fragment>
                                                }
                                                {elementTableType === 'Orientation2' && <Fragment>
                                                    <div className="col-lg-12 col-12">
                                                        <div className="position-relative form-group">
                                                            <div className="form-row row">
                                                                <div className="col-lg-7 col-7">
                                                                    <label id="CollectorSlope2Label" htmlFor="CollectorSlope2">PV Collector Slope</label>
                                                                </div>
                                                                <div className="col-lg-3 col-3">
                                                                    <BindedInput
                                                                        className="form-control"
                                                                        id="CollectorSlope2"
                                                                        name="CollectorSlope2"
                                                                        type="number"
                                                                        binding={[viewModel, "collectorSlope2", bindingViewModel]}
                                                                    ></BindedInput>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12 col-12">
                                                        <div className="position-relative form-group">
                                                            <div className="form-row row">
                                                                <div className="col-lg-7 col-7">
                                                                    <label id="Size2Label" htmlFor="Size2">PV Size</label>
                                                                </div>
                                                                <div className="col-lg-3 col-3">
                                                                    <BindedInput
                                                                        className="form-control"
                                                                        id="Size2"
                                                                        name="Size2"
                                                                        type="number"
                                                                        binding={[viewModel, "size2", bindingViewModel]}
                                                                    ></BindedInput>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12 col-12">
                                                        <div className="position-relative form-group">
                                                            <div className="form-row row">
                                                                <div className="col-lg-7 col-7">
                                                                    <label id="AzimuthAngle2Label" htmlFor="AzimuthAngle2">PV Collector Surface Azimuth Angle</label>
                                                                </div>
                                                                <div className="col-lg-3 col-3">
                                                                    <BindedInput
                                                                        className="form-control"
                                                                        id="AzimuthAngle2"
                                                                        name="AzimuthAngle2"
                                                                        type="number"
                                                                        binding={[viewModel, "azimuthAngle2", bindingViewModel]}
                                                                    ></BindedInput>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12 col-12">
                                                        <div className="position-relative form-group">
                                                            <div className="form-row row">
                                                                <div className="col-lg-7 col-7">
                                                                    <label id="DiffuseReflectance2Label" htmlFor="DiffuseReflectance2">Diffuse Reflectance</label>
                                                                </div>
                                                                <div className="col-lg-3 col-3">
                                                                    <BindedInput
                                                                        disabled
                                                                        className="form-control"
                                                                        id="DiffuseReflectance2"
                                                                        name="DiffuseReflectance2"
                                                                        type="number"
                                                                        binding={[viewModel, "diffuseReflectance2", bindingViewModel]}
                                                                    ></BindedInput>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    </Fragment>
                                                }
                                                {elementTableType === 'Orientation3' && <Fragment>
                                                    <div className="col-lg-12 col-12">
                                                        <div className="position-relative form-group">
                                                            <div className="form-row row">
                                                                <div className="col-lg-7 col-7">
                                                                    <label id="CollectorSlope3Label" htmlFor="CollectorSlope3">PV Collector Slope</label>
                                                                </div>
                                                                <div className="col-lg-3 col-3">
                                                                    <BindedInput
                                                                        className="form-control"
                                                                        id="CollectorSlope3"
                                                                        name="CollectorSlope3"
                                                                        type="number"
                                                                        binding={[viewModel, "collectorSlope3", bindingViewModel]}
                                                                    ></BindedInput>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12 col-12">
                                                        <div className="position-relative form-group">
                                                            <div className="form-row row">
                                                                <div className="col-lg-7 col-7">
                                                                    <label id="Size3Label" htmlFor="Size3">PV Size</label>
                                                                </div>
                                                                <div className="col-lg-3 col-3">
                                                                    <BindedInput
                                                                        className="form-control"
                                                                        id="Size3"
                                                                        name="Size3"
                                                                        type="number"
                                                                        binding={[viewModel, "size3", bindingViewModel]}
                                                                    ></BindedInput>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12 col-12">
                                                        <div className="position-relative form-group">
                                                            <div className="form-row row">
                                                                <div className="col-lg-7 col-7">
                                                                    <label id="AzimuthAngle3Label" htmlFor="AzimuthAngle3">PV Collector Surface Azimuth Angle</label>
                                                                </div>
                                                                <div className="col-lg-3 col-3">
                                                                    <BindedInput
                                                                        className="form-control"
                                                                        id="AzimuthAngle3"
                                                                        name="AzimuthAngle3"
                                                                        type="number"
                                                                        binding={[viewModel, "azimuthAngle3", bindingViewModel]}
                                                                    ></BindedInput>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12 col-12">
                                                        <div className="position-relative form-group">
                                                            <div className="form-row row">
                                                                <div className="col-lg-7 col-7">
                                                                    <label id="DiffuseReflectance3Label" htmlFor="DiffuseReflectance3">Diffuse Reflectance</label>
                                                                </div>
                                                                <div className="col-lg-3 col-3">
                                                                    <BindedInput
                                                                        disabled
                                                                        className="form-control"
                                                                        id="DiffuseReflectance3"
                                                                        name="DiffuseReflectance3"
                                                                        type="number"
                                                                        binding={[viewModel, "diffuseReflectance3", bindingViewModel]}
                                                                    ></BindedInput>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    </Fragment>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="main-card mb-3 card">
                    <div className="card-header">
                        <button type="button" data-toggle="collapse" data-target="#HeatingConditionersListDiv" aria-expanded="true" aria-controls="HeatingConditionersListDiv" className="text-left m-0 p-0 btn btn-block">
                            <h5 className="m-0 p-0 card-title">Battery Configuration</h5>
                        </button>
                    </div>
                    <div data-parent="#HeatingConditionersList" id="HeatingConditionersListDiv" className="collapse show">
                        <div className="card-body">
                            <div className="separator"></div>
                            <div className="form-row row">
                                <div className="custom-checkbox custom-control">
                                    <BindedCheckBox
                                        id="BatteryPresent"
                                        name="BatteryPresent"
                                        className="custom-control-input"
                                        binding={[
                                            viewModel,
                                            "batteryPresent",
                                            bindingViewModel,
                                        ]}
                                    ></BindedCheckBox>
                                    <label
                                        style={{ marginLeft: "5px" }}
                                        htmlFor="BatteryPresent"
                                        className="custom-control-label"
                                    >
                                        Battery Present
                                    </label>
                                </div>
                            </div>
                            <div className="form-row row">
                                <div className="col-4">
                                    <div className="position-relative form-group">
                                        <label htmlFor="BatteryType">Battery Type *</label>
                                        <BindedSelect
                                            disabled={!viewModel.batteryPresent}
                                            className="form-control"
                                            id="BatteryType"
                                            name="BatteryType"
                                            options="batteryTypes"
                                            validate={formValidate}
                                            binding={[viewModel, "batteryTypeId", bindingViewModel]}
                                        ></BindedSelect>
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="position-relative form-group">
                                        <label htmlFor="BatteryCapacity">Battery Capacity </label>
                                        <BindedInput
                                            disabled={!viewModel.batteryPresent}
                                            className="form-control"
                                            id="BatteryCapacity"
                                            name="BatteryCapacity"
                                            type="number"
                                            binding={[viewModel, "batteryCapacity", bindingViewModel]}
                                        ></BindedInput>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="main-card mb-3 card">
                    <div className="card-header">
                        <button type="button" data-toggle="collapse" data-target="#HeatingConditionersListDiv" aria-expanded="true" aria-controls="HeatingConditionersListDiv" className="text-left m-0 p-0 btn btn-block">
                            <h5 className="m-0 p-0 card-title">Network export limit</h5>
                        </button>
                    </div>
                    <div data-parent="#HeatingConditionersList" id="HeatingConditionersListDiv" className="collapse show">
                        <div className="card-body">
                            <div className="separator"></div>
                            <div className="form-row row">
                                <div className="col-4">
                                    <div className="position-relative form-group">
                                        <label htmlFor="NetworkLimit">Network export limit (kW)</label>
                                        <BindedInput
                                            className="form-control"
                                            id="NetworkLimit"
                                            name="NetworkLimit"
                                            type="number"
                                            validate={formValidate}
                                            binding={[viewModel, "networkLimit", bindingViewModel]}
                                        ></BindedInput>
                                    </div>
                                </div>
                            </div>
                            <div className="form-row-separator"></div>
                            <div className="form-row row"></div>
                            <div className="form-row row">
                                <div className="col-12">
                                    <button type="button" style={{marginTop:"10px"}} className="btn btn-primary" onClick={submit}>Apply</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                    </>
                }
         
            </div>
        </Fragment>
    );
}
export default connectAppStore(SolarPvModule);